export const key = "0LF8bPi5BnOgl3JjLGcfhfU3N7TAk8rJ";
// 
export const baseURL = "https://admin.compareuniverse.com/";
// export const baseURL = "http://localhost:5000/";


// mongo string mongodb+srv://compare123:cKcA7MAvIuGRbK6Z@atlascluster.labrkuh.mongodb.net/compare